module.exports = __webpack_public_path__ + "img/70.8fb0f98e.jpg";